import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA ve çevrimdışı özellikler için service worker'ı kaydedin.
// reportWebVitals() yerine bunu kullanın.
serviceWorkerRegistration.unregister();